import { useQuery } from '@tanstack/react-query';

import { getDatasets } from '~/api/experiments';
import type { Dataset } from '~/api/experiments';
import { parsePipelineVersion } from '~/scenes/Monitor/scenes/AgentLogs/utils/parsePipelineVersion';

export type AgentDatasetsCollectScope = {
  realm: string;
  pipelineName: string;
  pipelineVersion: string;
  connectorId: string;
};

export const agentDatasetsForCollectQueryKey = (
  scope: AgentDatasetsCollectScope & { version: number }
) =>
  [
    'agent-logs',
    'datasets-for-collect',
    {
      realm: scope.realm,
      pipelineName: scope.pipelineName,
      version: scope.version,
      connectorId: scope.connectorId
    }
  ] as const;

type UseAgentDatasetsForCollectParams = AgentDatasetsCollectScope & {
  enabled?: boolean;
};

export function useAgentDatasetsForCollect({
  realm,
  pipelineName,
  pipelineVersion,
  connectorId,
  enabled = true
}: UseAgentDatasetsForCollectParams) {
  const version = parsePipelineVersion(pipelineVersion);

  return useQuery<Dataset[]>({
    queryKey: agentDatasetsForCollectQueryKey({
      realm,
      pipelineName,
      pipelineVersion,
      connectorId,
      version
    }),
    queryFn: () => getDatasets(realm, pipelineName, version, connectorId),
    enabled:
      enabled && !!realm && !!pipelineName && !!connectorId && version > 0,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false
  });
}
